module.exports = __webpack_public_path__ + "static/media/server-error.3098f2c4.svg";